import SettingsConfig from "@/views/admin/settings/Config";

export default {
  path: "settings/config",
  name: "settings-config",
  component: SettingsConfig,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
